var map = {
	"./landing/panelak": 46,
	"./landing/panelak.jpg": 46,
	"./landing/panelak2": 47,
	"./landing/panelak2.jpg": 47,
	"./logo": 48,
	"./logo-icon": 49,
	"./logo-icon.png": 49,
	"./logo.png": 48,
	"./podpis": 50,
	"./podpis.jpg": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;